module.exports = __webpack_public_path__ + "img/banner_culture_2.c159bd42.png";